import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-linen mt-24" data-testid="site-footer">
      <div className="container-edge py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-6">
              <p className="text-2xl md:text-3xl tracking-wide" style={{ fontFamily: "Playfair Display, serif" }}>
                Champagne <span className="text-sand" style={{ fontStyle: "italic" }}>&amp;</span> <span className="text-sand">Sunshine</span>
              </p>
              <p className="mt-1 text-[10px] tracking-[0.28em] uppercase text-soft">Real Estate Team</p>
            </div>
            <h3 style={{ fontFamily: "Playfair Display, serif" }} className="text-3xl md:text-4xl leading-tight">
              Let's find your place under the California sun.
            </h3>
            <p className="mt-6 text-soft max-w-md">
              Whether buying, selling, investing, or coaching — the Champagne &amp; Sunshine team
              brings local insight, calm guidance, and a network you can trust.
            </p>
            <Link to="/contact" className="btn-primary mt-8" data-testid="footer-cta-btn">
              Start the conversation
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Explore</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/coaching" className="hover:text-sand transition-colors">Coaching</Link></li>
              <li><Link to="/join-team" className="hover:text-sand transition-colors">Join the Team</Link></li>
              <li><Link to="/escrow" className="hover:text-sand transition-colors">Escrow</Link></li>
              <li><Link to="/resources" className="hover:text-sand transition-colors">Resources</Link></li>
              <li><Link to="/lifestyles" className="hover:text-sand transition-colors">Lifestyles</Link></li>
              <li><Link to="/community" className="hover:text-sand transition-colors" data-testid="footer-events-link">Events</Link></li>
              <li><Link to="/deal-room" className="hover:text-sand transition-colors">The Deal Room</Link></li>
              <li><Link to="/client-library" className="hover:text-sand transition-colors">Client Library</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-4">Connect</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone size={14} className="text-sand" />
                <a href={SITE.teamPhoneHref} data-testid="footer-phone">{SITE.teamPhone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={14} className="text-sand" />
                <a href={SITE.emailHref} data-testid="footer-email" className="break-all">{SITE.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={14} className="text-sand" />
                <span>{SITE.serviceArea}</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-sand transition-colors" data-testid="social-instagram"><Instagram size={18} /></a>
              <a href={SITE.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-sand transition-colors" data-testid="social-facebook"><Facebook size={18} /></a>
              <a href={SITE.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="hover:text-sand transition-colors" data-testid="social-youtube"><Youtube size={18} /></a>
            </div>
          </div>
        </div>

        <div className="palm-divider mt-16 mb-8" />
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-soft">
          <p>© {new Date().getFullYear()} Champagne &amp; Sunshine Real Estate Team · KW L.A. Harbor · KW Luxury · KW Sports + Entertainment · {SITE.dre}</p>
          <p>Each Office is Independently Owned and Operated · Greater LA</p>
        </div>
      </div>
    </footer>
  );
}
